import {
  removeFilter,
  removeHighlightedTask,
  removeItemFromSearchHistory,
  SearchItem,
} from "../../store/search";
import { ReactComponent as BlackStars } from "../../assets/icons/stars_black.svg";
import { ReactComponent as Profile } from "../../assets/icons/Profile.svg";
import { ReactComponent as XIcon } from "../../assets/icons/x_grey.svg";
import GreyOpacityText from "../UI/textFields/GreyOpacityText";
import ColouredRoundWrapper from "../UI/wrappers/ColouredRoundWrapper";
import { useAppDispatch } from "../../store/hooks";

const SearchItemChip = ({ searchResult }: { searchResult: SearchItem }) => {
  const dispatch = useAppDispatch();

  return (
    <ColouredRoundWrapper
      bgColor={"#F9F9F9"}
      height={"23px"}
      width={"fit-content"}
      classes="border rounded-full whitespace-nowrap px-2.5 cursor-pointer"
      onClick={() => {
        dispatch(removeHighlightedTask(searchResult.ids[0]));
        dispatch(removeItemFromSearchHistory(searchResult));
        dispatch(removeFilter(searchResult));
      }}
    >
      {searchResult.itemType === "TASK" ? (
        <BlackStars height={12} width={12} />
      ) : (
        <Profile height={12} width={12} />
      )}
      <GreyOpacityText size={"SMALL"}>{searchResult.string}</GreyOpacityText>
      <XIcon width={12} height={12} />
    </ColouredRoundWrapper>
  );
};

export default SearchItemChip;
